import {
    GET_DOMAINS_AND_CATEGS_REQUEST,
    GET_DOMAINS_AND_CATEGS_SUCCESS,
    GET_DOMAINS_AND_CATEGS_FAILED,
    DELETE_CATEGORY_SUCCESS,
    DELETE_CATEGORY_FAILED,
    DELETE_NOTIFICATIONS_CATEGORY_SUCCESS,
    DELETE_NOTIFICATIONS_CATEGORY_FAILED,
} from '../../actions/superadmin/domains-categories'

import _ from 'lodash';

const initialState = {
    all: {},
    requesting: false,
    error: null,
    deleting: false
}

export const domains = (state = initialState, action) => {
    switch (action.type) {
        case GET_DOMAINS_AND_CATEGS_REQUEST:
            return Object.assign({}, state, {
                requesting: true,
                error: null
            })
        case GET_DOMAINS_AND_CATEGS_SUCCESS:
            return Object.assign({}, state, {
                all: action.payload.data.payload.domains,
                requesting: false,
                error: null,
            })
        case GET_DOMAINS_AND_CATEGS_FAILED:
            return Object.assign({}, state, {
                requesting: false,
                error: action.error
            })
        case DELETE_NOTIFICATIONS_CATEGORY_SUCCESS:
        case DELETE_CATEGORY_SUCCESS:
            return Object.assign({}, state, {
                deleting: false,
                all: _.map(state.all, domain => {
                    return Object.assign({}, domain, {categories: domain.categories.filter(category => {
                        return category.id !== action.payload.data.payload._id
                    })})
                })
            })
        case DELETE_NOTIFICATIONS_CATEGORY_FAILED:
        case DELETE_CATEGORY_FAILED:
            return Object.assign({}, state, {
                deleting: false,
                error: action.error
            })
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/superadmin/domains-categories.js